import type { RouteRecordRaw } from 'vue-router'
import KycPage from './KycPage.vue'

export const kycRoutes: RouteRecordRaw[] = [
  {
    path: '/compliance/kyc',
    name: 'compliance.kyc',
    component: KycPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
